var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"error-no-access"},[_c('screen-no-access',{attrs:{"label":_vm.$t('error.button.login')}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }